<div #homePage class="clear"></div>
@if (gotDataFromBlob) {
  <div>
    <app-home-banner [bannerContent]="homePageContent.homeBannerContent"></app-home-banner>
    <app-products-offered [productsContent]="homePageContent.productsOffered"></app-products-offered>
  </div>
}